import { ShieldOff } from "lucide-react";

import { Skeleton } from "@/components/ui/skeleton";

import { VoltEmpty } from "../ui/VoltEmpty";

export const FundingDenied = ({ reason }: { reason: string }) => (
  <VoltEmpty
    icon={ShieldOff}
    title="Kein Zugang zum Quartiersfonds"
    description={reason}
  />
);

export const FundingLoading = () => (
  <div className="flex flex-col gap-2" aria-busy>
    <Skeleton className="h-8 w-64" />
    <Skeleton className="h-32 w-full" />
  </div>
);
